import { render, staticRenderFns } from "./GPriceFormInput.vue?vue&type=template&id=b0e6d720&scoped=true&"
import script from "./GPriceFormInput.vue?vue&type=script&lang=ts&"
export * from "./GPriceFormInput.vue?vue&type=script&lang=ts&"
import style0 from "./GPriceFormInput.vue?vue&type=style&index=0&id=b0e6d720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e6d720",
  null
  
)

export default component.exports